import type { BrandKit } from '@doer/frontend-components/creativity-editor';
import { MACRO_BRAND_KIT } from './MACRO/brand-kit';
import { HIPOTECARIO_BRAND_KIT } from './HIPOTECARIO/_brand-kit/brand-kit';

const BRAND_KITS: Record<string, BrandKit> = {
  MACRO: MACRO_BRAND_KIT,
  HIPOTECARIO: HIPOTECARIO_BRAND_KIT,
  TEST: HIPOTECARIO_BRAND_KIT
};

const EMPTY_KIT: BrandKit = {};

export const getBrandKit = (clientId?: string): BrandKit => {
  if (!clientId) return EMPTY_KIT;
  return BRAND_KITS[clientId] ?? EMPTY_KIT;
};
